import type { ReactNode } from "react";
import * as React from "react";
import * as palette from "../../palette";

interface IMenuProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLUListElement>, HTMLUListElement> {
  children: ReactNode;
}

export default function Menu({ children, ...props }: IMenuProps) {
  return (
    <ul
      css={{
        display: "grid",
        gridRowGap: 4,
        minWidth: 180,
        maxWidth: 280,
        margin: 0,
        padding: "8px 12px",
        listStyle: "none",
        border: `solid 1px ${palette.mystic}`,
        borderRadius: 4,
      }}
      {...props}
    >
      {children}
    </ul>
  );
}
